<template>
  <div class="panel">
    <div
      class="item"
      v-for="item in list"
      :key="item.id"
      @click="selectItem(item)"
      :class="{active: item.active}"
    >{{item.faceValue}}元</div>
  </div>
</template>

<script>
import api from "../../api";

export default {
  props: ["disabled"],
  data() {
    return {
      list: []
    };
  },
  methods: {
    selectItem(item) {
      if (this.disabled) {
        this.list.forEach(i => {
          i.active = false;
        });
        item.active = true;
        var data = {
          pricePoint: item.pricePoint,
          productId: item.productId,
          faceValue: item.faceValue,
        }
        this.$emit("select", data);
      } else {
        this.list.forEach(i => {
          i.active = false;
        });
      }
    },
    getList() {
      api.charge.getProductList((res) => {
        console.log(res);
        res.list.forEach(i => {
          i['active'] = false
        })
        this.list = res.list
      })
    }
  },
  watch: {
    disabled(val) {
      if (!val) {
        this.list.forEach(i => {
          i.active = false;
        });
      }
    }
  },
  mounted() {
    this.getList()
  }
};
</script>

<style lang="less" scoped>
.panel {
  display: flex;
  flex-wrap: wrap;
  padding: 9.06vw 5.6vw 8vw 5.6vw;
  justify-content: flex-start;
  .item {
    width: 30vw;
    background: #f2f2f2;
    width: 25.66vw;
    height: 12vw;
    border-radius: 3px;
    margin-bottom: 2.66vw;
    text-align: center;
    line-height: 12vw;
    color: #333;
    margin-right: 3.2vw;
    &:nth-child(3n) {
      margin-right: 0
    }
    &.active {
      background: #ff3340;
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/charge/NumberPanel.vue